import { ApolloClient, HttpLink, InMemoryCache, concat } from '@apollo/client/core'
import { errorLink, authLink } from './shared-links.js'

// HTTP Link Configuration for Secondary API
const httpLink = new HttpLink({
  uri: process.env.VUE_APP_ENV === "production"
    ? "https://api.vibrant-america.com/v2/portal/trans-service/graphql" // production
    : "https://api.vibrant-america.com/v2/portal/trans-service-st/graphql", // staging
})



// Create Apollo Client
export const transSericeApolloClient = new ApolloClient({
  link: concat(authLink, concat(errorLink, httpLink)),
  cache: new InMemoryCache()
})

export default transSericeApolloClient